/* eslint-disable no-unused-vars */
import _ from "lodash";
import React from "react";
import { useHttp } from "../../../../hooks/http";
import { URL_API } from "../../../../utils";
import SelectOption from "../../pos/components/SelectOption";

const SelectTeamName = ({ withAll = false, ...props }) => {
  const [loading, data, error, reload] = useHttp(
    {
      url: `${URL_API}/boss/report-component/teamname`,
      token: true,
      params: {},
    },
    [],
  );

  const teamOptions = [
    ..._.map(data?.data, (data) => {
      return { value: data.team_name, text: data.team_name };
    }),
  ];
  return (
    <SelectOption
      withAll={withAll}
      className="w-100"
      defaultValue=""
      options={teamOptions}
      {...props}
    />
  );
};

export default SelectTeamName;
